import { useGetDocumentOrderFilterDimensions } from "hooks/api/documents/documentFilterDimensions";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import { removeNullable } from "services/apiHelpers";
import {
  CheckboxListFilter,
  FilterOption,
} from "../GenericFilters/CheckboxListFilter";
import { FilterProps } from "../filter-definition";

export const OrdersModeFilter = ({ variant }: FilterProps) => {
  const cardCodes = useSelectedCustomerCode();

  const { data, isLoading } = useGetDocumentOrderFilterDimensions(cardCodes);

  const modeOptions: FilterOption[] = removeNullable(
    data?.modeOfTransportations?.map((mode) => ({
      label: mode.Name,
      value: mode.Code,
    })) ?? []
  );

  return (
    <CheckboxListFilter
      filterKey="mode"
      name="Mode"
      variant={variant}
      filterOptions={modeOptions}
      isLoading={isLoading}
    />
  );
};
